import { getUser } from "$lib/userstorage/usersotrage"
import categorias from "$lib/stores/categorias"
import { handleAuthenticatedRequest, handleTransferRequest, jsonOrThrow } from "../errores/erroresback"
import { saveOffline, updateOffline } from "$lib/outbox/saveOffline"
import { enqueue } from "$lib/outbox/outboxApi"
import { drainOutbox } from "$lib/sync/drainer"
import { queryKeys } from "$lib/query/keys"
import { queryClient, cacheRestored } from "$lib/query/queryClient"
import { loadStorageEstablecimiento } from "$lib/java/establecimientos/establecimientostorage"
import { processComments } from "../observaciones/observacionesback"
import { processTactos } from "../tactos/tactosback"
import { processNacimientos } from "../nacimientos/nacimientosback"
import { processServicios } from "../servicios/serviciosback"
import { processTreatmentEvents } from "../tratamientos/tratamientosback"
let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD == "si";
let RUTA_JAVA = bd_local ? ruta_local_java : ruta_java;
//Queso
const RUTA_ANIMALES = "animals"
function null2string(param) {
    return param ? param : ""
}
function string2null(param) {
    return param && param.length > 0 ? param : null
}
function getCategoriaId(categoryId) {
    let c_idx = categorias.findIndex(c => c.cod == categoryId)
    if (c_idx != -1) {
        return categorias[c_idx].id
    }
    else {
        return ""
    }
}
function getCategoriaCod(categoria) {
    let c_idx = categorias.findIndex(c => c.id == categoria)
    if (c_idx != -1) {
        return categorias[c_idx].cod
    }
    else {
        return null
    }
}
function processAnimal(animal) {
    if (animal == null) {
        return animal;
    }
    let data_animal = {
        id: animal.animalId,
        caravana: animal.tagNumber,
        active: animal.isActive,
        status: animal.status || null,
        delete: animal.isDeregistered ? animal.isDeregistered : animal.deathDate ? animal.deathDate.length > 0 : false,
        fechanacimiento: null2string(animal.birthDate),
        sexo: animal.sex == "F" ? "H" : "M",
        nacimiento: null2string(animal.birthId),
        // `?? null` y no `?? ""`: "sin peso" es lo que devuelve el server para un
        // animal sin pesajes. Sin esto queda `undefined` cuando la fila la arma el
        // alta offline (postData no emite currentWeight), y la ficha del animal
        // revienta al renderizar: +page hace `bind:peso` contra un $bindable con
        // fallback, y Svelte 5 prohibe bindear undefined (props_invalid_value).
        peso: animal.currentWeight ?? null,
        cab: animal.establishmentId,
        rodeo: null2string(animal.herdId),
        fechafallecimiento: animal.deathDate,
        fechaventa: animal.saleDate,
        lote: null2string(animal.lotId),
        categoria: getCategoriaId(animal.categoryId),
        nombrecategoria: null2string(animal.categoryName),
        prenada: animal.reproductiveStatus == "PRENADA" ? 2 : animal.reproductiveStatus == "EN_SERVICIO" ? 3 : 0,
        motivobaja: "",
        raza: null2string(animal.breed),
        color: animal.color?animal.color:"",
        rp: null2string(animal.rpCode),
        bancoPadres: animal.isStudBank === true,
        created: animal.creationDate,
        updated: animal.updateDate,
        // FP-08: solo tienen valor en el animal PENDING_ACCEPTANCE del destino.
        // transferMovementId es el Movement que agrupa los animales
        // transferidos juntos en un mismo movimiento (RN-28bis) — es lo que
        // hay que pasar a accept/reject, no transferId (que sigue siendo por animal).
        transferId: animal.transferId ?? null,
        transferMovementId: animal.transferMovementId ?? null,
        fromEstablishmentId: animal.fromEstablishmentId ?? null,
        fromEstablishmentName: animal.fromEstablishmentName ?? null,
        transferDate: animal.transferDate ?? null,
        expand: {
            lote: {
                id: animal.lotId,
                nombre: animal.lotName
            },
            rodeo: {
                id: animal.herdId,
                nombre: animal.herdName
            },
            nacimiento: {
                id: animal.birthId,
                fecha: animal.birthDate,
                madre: animal.motherId,
                padre: animal.fatherId,
                nombremadre: animal.motherTagNumber,
                nombrepadre: animal.fatherTagNumber,

                observacion: animal.birthNotes

            }
        }


    }
    return data_animal
}
export function processAnimales(data) {
    let data_animales = []
    for (let i = 0; i < data.length; i++) {
        let fila = data[i]

        data_animales.push(processAnimal(fila))
    }
    return data_animales
}
function processEventos(data) {
    
    let eventos = {
        tratamientos: processTreatmentEvents(data.treatmentEvents),
        observaciones: processComments(data.observations),
        servicios: processServicios(data.services),
        tactos: processTactos(data.pregnancyChecks),
        pariciones: processNacimientos(data.births)
    };
    
    return eventos
}
export async function getAnimalEventos(animalId) {
    let user = getUser();
    let token = user.token;

    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}/${animalId}/relations`
    let url = new URL(ruta);
    let options = {
        headers: {
            //"Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await handleAuthenticatedRequest(url.toString(), options)

    let data_all = await jsonOrThrow(res_all, "animales.getAnimalEventos")
    let procesada = processEventos(data_all)

    return procesada
}
export async function getAll(cabid = null, lotid = null, includeInactive = false, includeStudBank = false) {

    let user = getUser();
    let token = user.token;

    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}/all`
    // 1. Construir la URL base
    let url = new URL(ruta);

    // 2. Agregar los parámetros de consulta solo si tienen valor
    // Spring ignorará los null/undefined, pero es mejor no enviarlos para limpiar la URL
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }
    if (lotid) {
        url.searchParams.append('lotId', lotid);
    }
    if (includeInactive) {
        url.searchParams.append('includeInactive', 'true');
    }
    if (includeStudBank) {
        url.searchParams.append('includeStudBank', 'true');
    }
    let options = {
        headers: {
            //"Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    try {
        let res_all = await handleAuthenticatedRequest(url.toString(), options)

        let data_all = await jsonOrThrow(res_all, "animales.getAll")

        let procesada = processAnimales(data_all)

        return procesada
    } catch (err) {
        if (isRealError(err)) throw err
        await cacheRestored
        const cached = findAnimalListInCache(cabid, includeInactive, includeStudBank)
        if (cached) {
            return lotid ? cached.filter((a) => String(a.lote) === String(lotid)) : cached
        }
        throw err
    }
}
function isRealError(err) {
    return !!err && (err.message === "SESIÓN_EXPIRADA" || err.message === "SIN_PERMISO" || typeof err.status === "number")
}
function findAnimalListInCache(cabid, includeInactive, includeStudBank) {
    try {
        const baseKey = queryKeys.animals(cabid)
        const suffix = includeStudBank ? "withStudBank" : includeInactive ? "all" : null
        const key = suffix ? [...baseKey, suffix] : baseKey
        const lista = queryClient.getQueryData(key)
        return Array.isArray(lista) ? lista : null
    } catch (e) {
        return null
    }
}
// Busca un animal ya procesado en el cache de TanStack (lista sembrada por el
// snapshot en `["animals", estId]` y por la pantalla de lista en
// `["animals", estId, "all"]`). Fallback offline de getAnimalId: el detalle no se
// cachea individualmente, pero la lista sí y comparte el shape de processAnimal.
function findAnimalInCache(id) {
    try {
        const estId = loadStorageEstablecimiento()?.id
        if (estId == null || estId === "") return null
        const listas = [
            queryClient.getQueryData([...queryKeys.animals(estId), "all"]),
            queryClient.getQueryData(queryKeys.animals(estId)),
        ]
        for (const lista of listas) {
            if (Array.isArray(lista)) {
                const found = lista.find((a) => String(a.id) === String(id))
                if (found) return found
            }
        }
        return null
    } catch (e) {
        return null
    }
}

export async function getAnimalId(id) {
    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}/${id}`
    let user = getUser();
    let token = user.token;
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    try {
        let res_all = await fetch(ruta, options)
        let data_all = await res_all.json()
        let procesada = processAnimal(data_all)
        return procesada
    } catch (err) {
        // Red caida (offline): el fetch se rechaza. Servir el animal desde el
        // cache de la lista para que el detalle cargue sin red. Si no esta en el
        // cache (ej. animal inactivo fuera del snapshot), devolver null: los
        // callers (perfilAnimal / getMadre / getPadre) lo tratan sin romper.
        await cacheRestored
        const cached = findAnimalInCache(id)
        if (cached) return cached
        return null
    }
}
function postData(data, establishmentId = 1) {
    let sex = !data.sexo || data.sexo.length==0?"F":data.sexo == "H" ? "F" : "M"
    let data_animal = {
        tagNumber: data.caravana,
        birthDate: data.fechanacimiento && data.fechanacimiento.length > 0 ? data.fechanacimiento.split(" ")[0] : "",
        sex,
        rpCode: data.rp,
        establishmentId: data.cab,
        breed: data.raza,
        color: data.color,
        herdId: data.rodeo || null,
        lotId: data.lote || null,
        birthId: data.nacimiento || null,
        categoryId: data.categoria && data.categoria.length>0? getCategoriaCod(data.categoria):sex=="F"?4:3,
        reproductiveStatus: data.prenada == 2 ? "PRENADA" : data.prenada == 3 ? "EN_SERVICIO" : "VACIA",
        isStudBank: data.isStudBank ?? false,
    }

    return data_animal
}
function updateData(animal) {
    let data_animal = {

        tagNumber: animal.caravana,
        // AnimalDto.birthDate/deathDate son LocalDate (solo fecha): si el caller pasa
        // un datetime ("2026-07-07 03:00:00", ej. la edición de nacimiento), el batch
        // falla al deserializar. Sacamos la hora, igual que postData en el CREATE.
        birthDate: string2null((animal.fechanacimiento || "").split(" ")[0]),
        sex: animal.sexo == "H" ? "F" : "M",

        deathDate: string2null((animal.fechafallecimiento || "").split(" ")[0]),

        breed: string2null(animal.raza),
        color: string2null(animal.color),
        rpCode: animal.rp,
        establishmentId: animal.cab,

        birthId: animal.nacimiento,
        herdId: animal.rodeo,
        reproductiveStatus: animal.prenada == 2 ? "PRENADA" : animal.prenada == 3 ? "EN_SERVICIO" : "VACIA",
        lotId: animal.lote,
        categoryId: getCategoriaCod(animal.categoria)


    }
    return data_animal
}
// Keys de animales que hay que mantener en sincro ante cualquier mutación
// optimista offline sobre un animal existente (editar/dar de baja): la BASE
// (selectores de movimientos/tactos/tratamientos/etc + seedFromSnapshot), y
// dos variantes que seedFromSnapshot NO siembra al login — solo se llenan si
// la pantalla que las usa ya corrió esta sesión — "all" (/animales, incluye
// inactivos) y "withStudBank" (selector de madres/padres de servicios/
// inseminaciones/nacimientos, incluye banco de padres). Tocar solo "all" (como
// hacía antes editAnimalOffline/darBajaOffline) dejaba tactos y servicios
// mostrando el animal desactualizado hasta reconectar.
function animalListKeys(cabid) {
    const baseKey = queryKeys.animals(cabid)
    return [baseKey, [...baseKey, "all"], [...baseKey, "withStudBank"]]
}

// Aplica `updater` (recibe la lista vieja cacheada, devuelve la nueva) a cada
// key en `keys` (default: las tres de animalListKeys) que ya esté cacheada;
// las que no, se dejan como están. Devuelve una función de rollback para el
// catch del caller.
function patchAnimalListsOptimistic(cabid, updater, keys = animalListKeys(cabid)) {
    const previos = keys.map((key) => [key, queryClient.getQueryData(key)])
    for (const [key, prev] of previos) {
        if (Array.isArray(prev)) queryClient.setQueryData(key, updater(prev))
    }
    return () => {
        for (const [key, prev] of previos) {
            if (Array.isArray(prev)) queryClient.setQueryData(key, prev)
        }
    }
}

// Alta de animal OFFLINE-first (Frente B, alta simple). Mismo `data` de pantalla
// que saveAnimal, pero en vez de POST directo: optimistic update en la lista de
// animales + encola un "animal" en la outbox (idempotency por clientUuid) + drena.
// Reusa postData (arma el AnimalDto) y processAnimal (shape de la lista). El id
// optimista es "pending-<uuid>" (no real): editarlo o eliminarlo antes de que
// sincronice se colapsa sobre este mismo CREATE (ver saveOffline).
// NO cubre la cría-en-nacimiento (depende del id del server).
export async function saveAnimalOffline(data) {
    const payload = postData(data)
    const cabid = payload.establishmentId ?? data.cab
    // El id optimista es `pending-<clientUuid>` con el MISMO uuid que la op del
    // outbox (se lo pasamos a saveOffline). Así, cuando el animal sincroniza el
    // drainer aprende clientUuid→serverId y puede resolver las FKs de los hijos
    // creados offline que apuntan a este `pending-<clientUuid>` (observación,
    // pesaje, etc. de un animal recién creado sin conexión).
    const clientUuid = crypto.randomUUID()
    const optimisticRow = processAnimal({
        ...payload,
        animalId: `pending-${clientUuid}`,
        isActive: true,
        herdName: data.rodeonombre ?? "",
        lotName: data.lotenombre ?? "",
        categoryName: data.categoria ?? "",
    })
    // saveOffline siembra la key BASE ["animals", estId] (la que usan los
    // selectores de movimientos/tactos/tratamientos/etc y seedFromSnapshot).
    // Pero hay otras dos variantes que seedFromSnapshot NO siembra al login —
    // solo se llenan si esta sesión ya visitó la pantalla que las usa — y sin
    // eso el alta offline quedaba invisible ahí hasta reconectar:
    //   - ["animals", estId, "all"] (incluye inactivos): lista principal /animales.
    //   - ["animals", estId, "withStudBank"]: selector de madres/padres de
    //     servicios/inseminaciones/nacimientos (incluye banco de padres).
    // Fallback: si la variante no está cacheada todavía, arrancamos desde la
    // BASE (que sí trae el snapshot) en vez de saltear el prepend entero —
    // mejor mostrar activos + el recién creado que no mostrar nada.
    const baseKey = queryKeys.animals(cabid)
    const baseList = queryClient.getQueryData(baseKey)
    const extraVariants = ["all", "withStudBank"].map((suffix) => {
        const key = [...baseKey, suffix]
        const prevList = queryClient.getQueryData(key)
        const fallbackList = Array.isArray(prevList)
            ? prevList
            : Array.isArray(baseList)
              ? baseList
              : null
        if (fallbackList !== null) {
            queryClient.setQueryData(key, [
                { ...optimisticRow, _pendingSync: true, _clientUuid: clientUuid },
                ...fallbackList,
            ])
        }
        return { key, prevList, fallbackList }
    })
    try {
        return await saveOffline({
            entity: "animal",
            payload,
            queryKey: queryKeys.animals(cabid),
            optimisticRow,
            clientUuid,
        })
    } catch (err) {
        // Rollback del prepend si el encolado falló: restaura lo que había (si
        // la variante ya estaba cacheada) o borra el seed de fallback que
        // acabamos de crear (si no existía todavía).
        for (const { key, prevList, fallbackList } of extraVariants) {
            if (Array.isArray(prevList)) {
                queryClient.setQueryData(key, prevList)
            } else if (fallbackList !== null) {
                queryClient.removeQueries({ queryKey: key, exact: true })
            }
        }
        throw err
    }
}
// Edición de animal OFFLINE-first (Frente A / UPDATE). Igual que editAnimal pero
// vía outbox: optimistic sobre la lista + encola un UPDATE (idempotente por
// resourceId en el server). `data` = misma shape de pantalla que editAnimal; reusa
// updateData (arma el AnimalDto). La fila optimista se arma mergeando la fila
// cacheada con los campos editados (preserva expand.nacimiento y los nombres de
// rodeo/lote no cambiados). Apunta a la key de la LISTA (`["animals", estId, "all"]`),
// que es la que la pantalla de animales muestra. NO cubre peso ni parto (esos
// dependen de red / id del server → el caller los deja online).
export async function editAnimalOffline(id, data) {
    const payload = updateData(data)
    const cabid = payload.establishmentId ?? data.cab
    // Id CRUDO: un animal creado offline tiene id `pending-<uuid>` y Number() lo
    // volvía NaN, así que updateOffline no encontraba la fila y rebotaba con
    // PendingNotEditableError. updateOffline compara laxo (ver mismoId).
    const resourceId = id
    const listKey = [...queryKeys.animals(cabid), "all"]
    const lista = queryClient.getQueryData(listKey)
    const actual = Array.isArray(lista)
        ? lista.find((a) => String(a.id) === String(resourceId))
        : null
    const catNombre =
        categorias.find((c) => c.id == data.categoria)?.nombre ??
        actual?.nombrecategoria ??
        ""
    const optimisticRow = {
        ...(actual || {}),
        caravana: data.caravana,
        sexo: data.sexo,
        raza: data.raza ?? "",
        color: data.color ?? "",
        rp: data.rp ?? "",
        fechanacimiento: data.fechanacimiento ?? "",
        categoria: data.categoria ?? "",
        nombrecategoria: catNombre,
        rodeo: data.rodeo ?? "",
        lote: data.lote ?? "",
        prenada: data.prenada == 2 ? 2 : data.prenada == 3 ? 3 : 0,
        expand: {
            ...(actual?.expand || {}),
            rodeo: {
                id: data.rodeo,
                nombre: data.rodeonombre ?? actual?.expand?.rodeo?.nombre ?? "",
            },
            lote: {
                id: data.lote,
                nombre: data.lotenombre ?? actual?.expand?.lote?.nombre ?? "",
            },
        },
    }
    // updateOffline ya patchea "all" (listKey); acá cubrimos las otras dos
    // variantes (base y withStudBank) con el mismo merge, para que tactos y
    // servicios/inseminaciones/nacimientos vean la edición sin esperar el sync.
    const baseKey = queryKeys.animals(cabid)
    const otrasKeys = [baseKey, [...baseKey, "withStudBank"]]
    const rollbackOtras = patchAnimalListsOptimistic(
        cabid,
        (old) =>
            old.map((a) =>
                String(a.id) === String(resourceId) ? { ...a, ...optimisticRow, _pendingSync: true } : a,
            ),
        otrasKeys,
    )
    try {
        return await updateOffline({
            entity: "animal",
            resourceId,
            payload,
            queryKey: listKey,
            optimisticRow,
        })
    } catch (err) {
        rollbackOtras()
        throw err
    }
}
// Dar de baja OFFLINE-first (muerte/venta). A diferencia de un CREATE normal, el
// efecto optimista es MARCAR el animal como dado de baja (sale de la vista de
// activos), no insertar una fila. Encola un CREATE de `death`/`sale`; el backend es
// idempotente por estado del animal (no necesita clientUuid). Transfer NO usa esto:
// queda online-only. `motivo` = "fallecimiento" | "venta".
export async function darBajaOffline(data, motivo) {
    const esMuerte = motivo === "fallecimiento"
    const entity = esMuerte ? "death" : "sale"
    const cabid = loadStorageEstablecimiento()?.id
    const animalId = Number(data.animalId)
    const payload = esMuerte
        ? { animalId, date: data.date }
        : { animalId, saleDate: data.saleDate, price: data.price ?? 0 }
    const listKey = [...queryKeys.animals(cabid), "all"]
    // Optimistic: el animal pasa a inactivo/dado de baja (el filtro "activos" lo
    // oculta) en las tres variantes de la lista de animales — sin esto tactos
    // (key base) y servicios/inseminaciones/nacimientos (withStudBank) seguían
    // ofreciendo el animal ya dado de baja hasta que sincronizara.
    const rollback = patchAnimalListsOptimistic(cabid, (old) =>
        old.map((a) =>
            String(a.id) === String(animalId)
                ? {
                      ...a,
                      active: false,
                      delete: true,
                      _pendingSync: true,
                      ...(esMuerte
                          ? { fechafallecimiento: data.date }
                          : { fechaventa: data.saleDate }),
                  }
                : a,
        ),
    )
    try {
        const clientUuid = await enqueue(entity, "CREATE", payload, {
            queryKey: listKey,
            establishmentId: cabid,
        })
        drainOutbox().catch(() => {})
        return clientUuid
    } catch (err) {
        rollback()
        throw err
    }
}
export async function saveAnimal(data, establishmentId = 1) {
    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}`
    let data_animal = postData(data, establishmentId)
    let user = getUser();
    let token = user.token;
    let res_save = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(data_animal), // data can be `string` or {object}!
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    })
    // Sin este chequeo, un rechazo del backend se parseaba como si fuera el animal
    // creado: processAnimal sobre el cuerpo del error devolvía un objeto basura y
    // el caller seguía como si hubiera dado el alta. Con el tope del plan (409
    // PLAN_LIMIT_REACHED) eso significaba "creé el toro" cuando no se creó nada.
    if (!res_save.ok) {
        let body = {}
        try { body = await res_save.json() } catch (_) { /* respuesta sin cuerpo JSON */ }
        const err = new Error(body.message || `saveAnimal -> ${res_save.status}`)
        err.status = res_save.status
        err.code = body.code           // "PLAN_LIMIT_REACHED" cuando es tope de plan
        throw err
    }
    let data_save = await res_save.json()
    let animal = processAnimal(data_save)
    return animal

}
export async function darBajaAnimal(data, motivo) {
    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}`

    let user = getUser();
    let token = user.token;
    let headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
    }
    try {
        if (motivo == "fallecimiento") {
            let res_save = await fetch(ruta + "/death", {
                method: "POST",
                body: JSON.stringify(data), // data can be `string` or {object}!
                headers
            })
            
            if (res_save.status === 400) {
                throw new Error('Ya fallecido');
            }
        }
        else if (motivo == "venta") {
            let res_save = await fetch(ruta + "/sale", {
                method: "POST",
                body: JSON.stringify(data), // data can be `string` or {object}!
                headers
            })
            if (res_save.status === 400) {
                throw new Error('Ya fallecido');
            }
        }
    }
    catch (err) {
        throw new Error(err.message)
    }

}
export async function transferirAnimal(data) {
    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}`

    let user = getUser();
    let token = user.token;
    let headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
    }
    await handleTransferRequest(ruta + "/transfer", {
        method: "POST",
        body: JSON.stringify(data),
        headers
    })
}
// FP-08/RN-28bis: el establecimiento destino acepta/rechaza un MOVIMIENTO de
// transferencia pendiente completo (movementId, no transferId — un
// movimiento puede agrupar varios animales). 404 = el movimiento no existe o
// no sos el destino (IDOR); 400 = ya fue respondido (aceptado o rechazado antes).
async function postTransferAction(movementId, action) {
    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}/transfer/${movementId}/${action}`
    let user = getUser();
    let headers = { "Authorization": `Bearer ${user.token}` }
    let res = await handleAuthenticatedRequest(ruta, { method: "POST", headers })
    if (res.status === 404) throw new Error("not_found")
    if (res.status === 400) throw new Error("not_pending")
    if (!res.ok) throw new Error(action)
}
export async function acceptTransfer(movementId) {
    await postTransferAction(movementId, "accept")
}
export async function rejectTransfer(movementId) {
    await postTransferAction(movementId, "reject")
}
export async function eliminarAnimalJava(id) {
    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}`

    let user = getUser();
    let token = user.token;
    let headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
    }
    let res_save = await fetch(ruta + "/delete/" + id, {
        method: "POST",

        headers
    })
}
export async function editAnimal(id, data) {
    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}/${id}`

    let user = getUser();
    let token = user.token;
    let data_animal = updateData(data)
    try {
        let res_put = await fetch(ruta,
            {
                method: "PUT",
                body: JSON.stringify(data_animal), // data can be `string` or {object}!
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            }
        )

        let data_put = await res_put.json()
        return data_put
    }
    catch (err) {
        throw new Error(err)
    }

}
export async function eliminarAnimal(id) {
    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}/delete/${id}`
    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    });
    if (!res_post.ok) {
        throw new Error(`Error al eliminar: ${res_post.status}`);
    }
    return {}
}
export async function deleteAnimalsBulk(ids) {
    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}/delete-bulk`
    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(ids),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    });
    if (!res_post.ok) {
        throw new Error(`Error al eliminar: ${res_post.status}`);
    }
    return {}
}
export async function moverCategoria(ids, categoria, cabid, notes = "") {
    let ruta = `${RUTA_JAVA}${RUTA_ANIMALES}/category-movement`
    let data_move = {
        establishmentId: cabid,
        categoryId: getCategoriaCod(categoria),
        animalIds: ids,
        notes,
    }
    let user = getUser();
    let token = user.token;
    try {
        let res_save = await fetch(ruta, {
            method: "POST",
            body: JSON.stringify(data_move), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        })
        let data_save = await res_save.json()
        return data_move
    }
    catch (err) {
        throw new Error(err)
    }


}